import * as ambassadorWixBookingsPolicySnapshotsV1BookingPolicySnapshot from './bookings-policy-snapshots-v1-booking-policy-snapshot-booking-policy-snapshots.http.js';
import * as ambassadorWixBookingsPolicySnapshotsV1BookingPolicySnapshotTypes from './bookings-policy-snapshots-v1-booking-policy-snapshot-booking-policy-snapshots.types.js';
import * as ambassadorWixBookingsPolicySnapshotsV1BookingPolicySnapshotUniversalTypes from './bookings-policy-snapshots-v1-booking-policy-snapshot-booking-policy-snapshots.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function listPolicySnapshotsByBookingIds(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixBookingsPolicySnapshotsV1BookingPolicySnapshotUniversalTypes.ListPolicySnapshotsByBookingIdsRequest,
  ambassadorWixBookingsPolicySnapshotsV1BookingPolicySnapshotTypes.ListPolicySnapshotsByBookingIdsRequest,
  ambassadorWixBookingsPolicySnapshotsV1BookingPolicySnapshotUniversalTypes.ListPolicySnapshotsByBookingIdsResponse,
  ambassadorWixBookingsPolicySnapshotsV1BookingPolicySnapshotTypes.ListPolicySnapshotsByBookingIdsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBookingsPolicySnapshotsV1BookingPolicySnapshot.listPolicySnapshotsByBookingIds(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/policy-snapshots',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  BookingPolicySnapshot as BookingPolicySnapshotOriginal,
  BookingPolicy as BookingPolicyOriginal,
  PolicyDescription as PolicyDescriptionOriginal,
  CancellationPolicy as CancellationPolicyOriginal,
  ReschedulePolicy as ReschedulePolicyOriginal,
  CancellationFeePolicy as CancellationFeePolicyOriginal,
  Money as MoneyOriginal,
  CancellationWindow as CancellationWindowOriginal,
  CancellationWindowFeeOneOf as CancellationWindowFeeOneOfOriginal,
  SaveCreditCardPolicy as SaveCreditCardPolicyOriginal,
  IntakeFormPolicy as IntakeFormPolicyOriginal,
  Timing as TimingOriginal,
  TimingWithLiterals as TimingWithLiteralsOriginal,
  CompletionRequirement as CompletionRequirementOriginal,
  CompletionRequirementWithLiterals as CompletionRequirementWithLiteralsOriginal,
  ListPolicySnapshotsByBookingIdsRequest as ListPolicySnapshotsByBookingIdsRequestOriginal,
  ListPolicySnapshotsByBookingIdsResponse as ListPolicySnapshotsByBookingIdsResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  Empty as EmptyOriginal,
  ListPolicySnapshotsByBookingIdsApplicationErrors as ListPolicySnapshotsByBookingIdsApplicationErrorsOriginal,
} from './bookings-policy-snapshots-v1-booking-policy-snapshot-booking-policy-snapshots.types.js';
